import OpenspaceRoutes from 'openspace/containers/MainRouter/OpenspaceRoutes'
import { ReactElement } from 'react'

const ExtraRoutes: ReactElement[] = OpenspaceRoutes

export default ExtraRoutes
